import React from "react";

export function useIndexedDraftList<TItem>(initialItems: TItem[] = []) {
  const [items, setItems] = React.useState<TItem[]>(initialItems);
  const resetItems = React.useCallback((nextItems: TItem[]) => {
    setItems(nextItems);
  }, []);
  const addItem = React.useCallback((createItem: () => TItem) => {
    setItems((currentItems) => [...currentItems, createItem()]);
  }, []);
  const updateItem = React.useCallback((nextIndex: number, nextItem: TItem) => {
    setItems((currentItems) =>
      currentItems.map((currentItem, currentIndex) =>
        currentIndex === nextIndex ? nextItem : currentItem
      )
    );
  }, []);
  const removeItem = React.useCallback((nextIndex: number) => {
    setItems((currentItems) =>
      currentItems.filter((_, currentIndex) => currentIndex !== nextIndex)
    );
  }, []);

  return {
    addItem,
    items,
    removeItem,
    resetItems,
    setItems,
    updateItem,
  };
}
